import { Clock, CalendarDays, Globe, Timer } from "lucide-react";
import { fmtDateLong, fmtTime, isAbroad, localTzLabel, TZ, userTz } from "@/lib/format";

export function BookingSummary({ startUtc, duration }) {
  const rows = [
    [CalendarDays, "Date", fmtDateLong(startUtc, userTz), "summary-date"],
    [Clock, "Time", fmtTime(startUtc, userTz), "summary-time"],
    [Globe, "Time zone", localTzLabel(startUtc), "summary-timezone"],
    [Timer, "Duration", `${duration} minutes`, "summary-duration"],
  ];
  return (
    <div className="mt-6 rounded-3xl bg-[#0B1F3A] text-white p-6 grain relative overflow-hidden" data-testid="booking-summary">
      <p className="text-[11px] font-semibold uppercase tracking-[0.2em] text-[#C7A76C]">Your briefing</p>
      <dl className="mt-5 space-y-4">
        {rows.map(([Icon, k, v, tid]) => (
          <div key={k} className="flex gap-3">
            <Icon size={16} className="text-white/50 mt-0.5 shrink-0" />
            <div>
              <dt className="text-xs text-white/50">{k}</dt>
              <dd className="text-[15px] font-medium" data-testid={tid}>{v}</dd>
            </div>
          </div>
        ))}
      </dl>
      {isAbroad && (
        <p className="mt-5 pt-4 border-t border-white/10 text-xs text-white/60" data-testid="summary-dubai-time">
          In Dubai: {fmtTime(startUtc, TZ)} on {fmtDateLong(startUtc, TZ)} (GST, UTC+4)
        </p>
      )}
    </div>
  );
}
